module.exports = __webpack_public_path__ + "img/works_rakuten_gora_1.e316e35b.png";